// Last customers a user opened from the header search, kept in localStorage
// per employee *and* organization so nothing leaks between orgs a user
// belongs to. Only the fields the search item template needs are stored.

const LIMIT = 10

const storageKey = (userId, organizationId) =>
  `recent_customers:${userId}:${organizationId}`

const canUse = (userId, organizationId) =>
  Boolean(userId && organizationId && typeof window !== 'undefined')

function read(key) {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(key))
    return Array.isArray(parsed) ? parsed : []
  } catch (error) {
    return []
  }
}

export function getRecentCustomers(userId, organizationId) {
  if (!canUse(userId, organizationId)) {
    return []
  }

  return read(storageKey(userId, organizationId))
}

export function addRecentCustomer(userId, organizationId, customer) {
  if (!canUse(userId, organizationId)) {
    return
  }

  const key = storageKey(userId, organizationId)
  const entry = {
    id: customer.id,
    name: customer.name,
    personality: customer.personality,
    slug: customer.slug,
    query: customer.query,
  }
  const next = [entry, ...read(key).filter((c) => c.id !== entry.id)].slice(
    0,
    LIMIT,
  )

  try {
    window.localStorage.setItem(key, JSON.stringify(next))
  } catch (error) {
    // Storage full or blocked (private mode) — recents are a nicety only.
  }
}
